import React, { useEffect, useRef, useState } from 'react';
import BuilderSelct from '@/store/builderStoreSelector';
import { useDispatch } from 'react-redux';
import { BUILDER_FAILED, BUILDER_IN_PROGRESS, BUILDER_SUCCESS, DimensionalViewType, ProductPlacementType, SurfaceType } from '@/utils/builder/builderConstants';
import { saveProject as saveProjectThunk } from "@/store/builder/thunks/projectSaveThunk";
import { actions as builderActions } from "@/store/builderSlice";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { getBuilderConfigKey } from '@/utils/builder/builderConfig';

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SaveNotification() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const messageRef = useRef<{ severity: any; message: string, duration: number; }>({
    severity: '', message: '', duration: 0
  });
  const autoSaveDuration: number = getBuilderConfigKey('autoSaveDuration') as number;
  const saveStatus: string = BuilderSelct.ui().saveStatus;
  const isProjectDirty: boolean = BuilderSelct.ui().isProjectDirty;
  const isCustomRoomFlow: boolean = BuilderSelct.ui().isCustomRoomFlow;
  const urlParams: { [key: string]: string } = BuilderSelct.ui().urlParams;
  const layoutBuilderMode: string = BuilderSelct.ui().layoutBuilderMode;
  const saveStatusRef = useRef(saveStatus);
  const autoSaveRef = useRef(isProjectDirty);
  autoSaveRef.current = isProjectDirty && layoutBuilderMode !== DimensionalViewType.TWO_D && urlParams.createRoom !== 'true';
  const currentRole = urlParams.interiorDesigner === 'true' ? 'interiorDesigner' : ''
  const currentRoleRef = useRef(currentRole);
  currentRoleRef.current = currentRole;
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  if (saveStatusRef.current !== saveStatus) {
    saveStatusRef.current = saveStatus;
    setOpen(false);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoSaveRef.current) {
        console.log('auto save project', currentRoleRef.current);
        dispatch(builderActions.updateSaveStatus({ saveStatus: BUILDER_IN_PROGRESS }));
        dispatch(saveProjectThunk({ currentRole: currentRoleRef.current }) as any);
      }
    }, autoSaveDuration);

    return () => clearInterval(interval);
  }, [autoSaveDuration, dispatch]);

  useEffect(() => {
    switch (saveStatus) {
      case BUILDER_IN_PROGRESS:
        messageRef.current.severity = 'info';
        messageRef.current.message = "Project save in progress..";
        messageRef.current.duration = 0;
        break;
      case BUILDER_FAILED:
        messageRef.current.severity = 'error';
        messageRef.current.message = "Project save failed";
        messageRef.current.duration = 5000;
        break;
      case BUILDER_SUCCESS:
        messageRef.current.severity = 'success';
        messageRef.current.message = "Project saved successfully";
        messageRef.current.duration = 5000;
        break;
    }
    messageRef.current.severity !== '' && setOpen(true);
  }, [saveStatus])

  const autoHideDuration = messageRef.current.duration > 0 ? { autoHideDuration: messageRef.current.duration } : {};
  return (
    <Snackbar open={open}
      onClose={handleClose}
      anchorOrigin={{ 'vertical': 'top', 'horizontal': 'center' }}
      {...autoHideDuration}
    >
      <Alert onClose={handleClose} severity={messageRef.current.severity} sx={{ width: '100%' }}>
        {messageRef.current.message}
      </Alert>
    </Snackbar >
  );
}